// LineChart.js
import { Line } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    LineElement,
    CategoryScale,
    LinearScale,
    PointElement,
    Tooltip,
    Legend,
} from 'chart.js';

// Register components
ChartJS.register(
    LineElement,
    CategoryScale,
    LinearScale,
    PointElement,
    Tooltip,
    Legend
);

const LineChart = () => {
    const data = {
        labels: ['10', '20', '30', '40', '50'],
        datasets: [
            {
                label: 'Risk score in 7days',
                data: [150, 200, 180, 220, 250],
                borderColor: 'rgba(75,192,192,1)',
                backgroundColor: 'rgba(75,192,192,0.2)',
                tension: 0.4, // curve of the line
                fill: true,   // fill area below line
                pointRadius: 5,
            },
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
                labels: {
                    color: 'white', // legend text color
                },
            },
            tooltip: {
                mode: 'index',
                intersect: false,
            },
        },
        interaction: {
            mode: 'nearest',
            axis: 'x',
            intersect: false,
        },
        scales: {
            x: {
                ticks: {
                    color: 'white', // x-axis label color
                }
            },
            y: {
                beginAtZero: true,
                ticks: {
                    color: 'white', // x-axis label color
                },
            },
        },
    };

    return <Line data={data} options={options} />;
};

export default LineChart;
